export default __webpack_public_path__ + "static/media/SWT1370.34I-41058_-24521_0.53249ab2.jpg";